import * as STD          from '@emersya/mpa-std';
import * as CM                from '@emersya/mpa-components-manager';
import { InputButton }   from '@emersya/mpa-components';

export interface ICustomerInformationButtonComponentConfiguration extends InputButton.Configuration {
};

export class CustomerInformationButtonComponent extends InputButton.Component {

	async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		// await super.onValueUpdated(ev);
		if (ev.details.isDefaultValue) {
			return;
		}
		if (this.component_DOM.classList.contains('notReady')) {
			return;
		}
		await app.modals.useModal('oms-customerModal', void 1);
		// await app.update3DWithCustomerInformations();
	};

	override async component_start(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(ev);
		if (app.parameters.mode !== 'client') {
			this.component_DOM.classList.add('notReady');
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : ICustomerInformationButtonComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = CustomerInformationButtonComponent;
	export type Component = CustomerInformationButtonComponent;
	export type Configuration = ICustomerInformationButtonComponentConfiguration;
}
import manifestXMLSource from './OMSCustomerFormButton.xml';
import './OMSCustomerFormButton.scss';

CM.Manager.declare({
	id :       'oms-customerFormButton',
	type :     CustomerInformationButtonComponent,
	manifest : manifestXMLSource
});
